<template>
  <form class="create-or-edit-form" @submit.prevent.stop="submit">
    <div class="form-row">
      <p-text-field v-model.trim="name" :disabled="!$hasPermission('administration')" :label="'Name'" />
    </div>
    <div class="form-row">
      <p-multiselect
        v-model.trim="sttProvider"
        :disabled="!$hasPermission('administration')"
        :options="sttProviderOptions"
        :label="'Provider'"
        :searchable="false"
        placeholder=""
      />
    </div>
    <div class="form-row">
      <p-text-field v-model="description" :disabled="!$hasPermission('administration')" :label="'Description'" :multiline="true" :rows="3" />
    </div>
    <div class="form-row code">
      <label>Configuration</label>
      <p-code v-model="config" :read-only="!$hasPermission('administration')" :language="'json'"></p-code>
    </div>
    <div>
      <p-button type="button" @click.prevent="$router.back()">Cancel</p-button>
      <p-button v-if="$hasPermission('administration')" color="primary" type="submit">Save</p-button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';

import Multiselect from '@/components/common/Multiselect';
import TextField from '@/components/common/TextField';
import Button from '@/components/common/Button';
import Code from '@/components/common/Code';

export default {
  components: {
    'p-text-field': TextField,
    'p-multiselect': Multiselect,
    'p-button': Button,
    'p-code': Code
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    if (this.item) {
      return {
        sttProvider: this.item.sttProvider,
        name: this.item.name,
        description: this.item.description,
        config: (this.item.config && JSON.stringify(JSON.parse(this.item.config), null, 2)) || ''
      };
    } else {
      return {
        sttProvider: '',
        name: '',
        description: '',
        config: JSON.stringify({ property: 'value' }, null, 2)
      };
    }
  },
  computed: {
    ...mapState({
      sttServiceProviders: s => s.nlp.sttServiceProviders || {}
    }),
    sttProviderOptions() {
      return this.sttServiceProviders.map(p => p.name);
    }
  },
  async created() {
    const promises = [];

    if (!this.sttProvider?.length) {
      promises.push(this.$store.dispatch('nlp/getSttServices'));
    }

    await Promise.all(promises);
  },
  methods: {
    async submit() {
      this.$emit('submit', {
        ...this.item,
        sttProvider: this.sttProvider,
        name: this.name,
        description: this.description,
        config: JSON.stringify(JSON.parse(this.config))
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.create-or-edit-form {
  padding: 2rem;
  background: var(--theme-surface);
  overflow-y: auto;

  label {
    font-weight: 500;
    font-size: 0.75rem;
    letter-spacing: 0.025em;
  }

  .code {
    min-height: 300px;
  }

  > * {
    &:not(:last-child) {
      margin-bottom: 1.5rem;
    }
    &:last-child {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
